import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthAPI } from '../../api/client';
import {
  AuthLayout, ErrorText, InfoText, Turnstile, useAuthConfig,
  input, label, button, linkRow, linkStyle,
} from './authShared';

/** Enter the emailed verification code to confirm a sign-up (recovers accounts
 *  abandoned at this step). A resend option re-issues the code. */
export default function VerifyEmail() {
  const cfg = useAuthConfig();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [code, setCode] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setInfo('');
    if (!email.trim() || !code.trim()) { setError('Enter your email and the code.'); return; }
    setBusy(true);
    const r = await AuthAPI.confirm(email.trim(), code.trim());
    setBusy(false);
    if (r.ok && r.status === 'ok') { nav(`/login?verified=1`); return; }
    setError(r.message || 'That code is invalid or has expired.');
  };

  const resend = async () => {
    setError(''); setInfo('');
    if (!email.trim()) { setError('Enter your email first.'); return; }
    if (cfg?.captchaSiteKey && !captcha) { setError('Please complete the CAPTCHA before resending.'); return; }
    const r = await AuthAPI.resendCode(email.trim(), captcha);
    if (r.ok) setInfo('If that account needs verification, a new code is on its way.');
    else setError(r.message || 'Could not resend the code.');
  };

  return (
    <AuthLayout title="Verify your email" subtitle="Enter the code we emailed you.">
      <form onSubmit={submit}>
        <label style={label}>Email
          <input style={input} type="email" value={email} onChange={e => setEmail(e.target.value)} />
        </label>
        <label style={label}>Verification code
          <input style={input} inputMode="numeric" autoComplete="one-time-code" value={code}
                 onChange={e => setCode(e.target.value)} autoFocus />
        </label>
        {cfg?.captchaSiteKey && <Turnstile siteKey={cfg.captchaSiteKey} onToken={setCaptcha} />}
        {info && <InfoText>{info}</InfoText>}
        <ErrorText>{error}</ErrorText>
        <button type="submit" style={button} disabled={busy}>{busy ? 'Verifying…' : 'Verify'}</button>
      </form>
      <p style={linkRow}>
        Didn’t get it? <span style={linkStyle} onClick={resend}>Resend code</span>
        {' · '}<Link to="/login" style={linkStyle}>Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
